import { NgClass } from '@angular/common';
import { Component, ElementRef, Host, NO_ERRORS_SCHEMA, QueryList, ViewChildren } from '@angular/core';
import { DeviceBaseComponent } from '../../../device-base/device-base.component';

@Component({
  selector: 'app-polycom-vvx-em',
  standalone: true,
  templateUrl: './polycom-vvx-em.component.html',
  imports: [NgClass],
  styleUrls: ['../../../device-base/device-base.component.scss'],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PolycomVvxEmComponent {
  @ViewChildren('lineKeyButton') lineKeyButtons!: QueryList<ElementRef>;

  public readonly buttonsCount = 40;
  public readonly isPagingAvailable = false;

  constructor(@Host() public base: DeviceBaseComponent) {}

  getLineKeyButtons(): ElementRef<SVGPathElement>[] {
    return this.lineKeyButtons.toArray();
  }
}
